import React from 'react';
import './TokenScreens.css';

const STATUS_MESSAGES = {
  extracting: 'Preparing your account...',
  resolving: 'Verifying your link...',
  loading: 'Loading your account details...',
};

/**
 * Full-screen loading state shown while resolving a token and loading client data.
 * Provides reassuring, empathetic messaging while the user waits.
 */
export default function TokenLoadingScreen({ status }) {
  const message = STATUS_MESSAGES[status] || 'Loading...';

  return (
    <div className="token-screen" data-testid="loading-screen" role="status" aria-live="polite">
      <div className="token-screen__content">
        <div className="token-screen__logo" aria-hidden="true">
          <span className="token-screen__logo-icon">D</span>
        </div>
        <div className="token-screen__spinner" aria-hidden="true">
          <svg className="spinner-svg" viewBox="0 0 50 50">
            <circle
              className="spinner-circle"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="4"
            />
          </svg>
        </div>
        <p className="token-screen__message">{message}</p>
        <p className="token-screen__hint">This will only take a moment</p>
      </div>
    </div>
  );
}
